/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import { useForm } from 'react-hook-form';
// @ts-ignore
// import { useRecaptcha } from 'react-hook-recaptcha';
import { addNewCase_CAPAsync } from '../../actions/DataActionExtension.g';
import { IWebFormViewProps } from './webform';

// const sitekey = '6Ld1dKEaAAAAAEFVPf1NEKhRp8-DeabNW0vRaanw';
// const containerId = 'test-recaptcha';

// tslint:disable-next-line:max-func-body-length
const WebFormView: React.FC<IWebFormViewProps> = props => {
    type Inputs = {
        title: string;
        firstName: string;
        lastName: string;
        email: string;
        phoneNumber: string;
        category: string;
        subcategory: string;
        text: string;
        privacy: boolean;
    };
    interface IMaincategories {
        text: string;
        value: string;
    }
    // const onSubmit = data => console.log(data);
    const locale = props?.context?.request?.locale;
    const [loading, setLoading] = React.useState(false);
    const [subscribeMessage, setSubscribeMessage] = React.useState({
        state: false,
        message: '',
        class: ''
    });
    let message = props.thankYouMessageString || 'Thank you for contact us. We will contact you as soon as possible';
    // @ts-ignore
    const _sendWebForm = async data => {
        setLoading(true);
        addNewCase_CAPAsync(
            { callerContext: props.context?.actionContext },
            channelId,
            data.firstName,
            data.lastName,
            data.email,
            data.phoneNumber,
            data.category,
            data.subcategory ? data.subcategory : '',
            data.title,
            data.text
        )
            .then(result => {
                message = result.Error ? result.Error : message;
                setLoading(false);
                setSubscribeMessage({
                    state: true,
                    message: message,
                    class: 'success'
                });
            })
            .catch(error => {
                message = error.message;
                setLoading(false);
                setSubscribeMessage({
                    state: true,
                    message: error.message,
                    class: 'error'
                });
            });
    };

    const { register, handleSubmit, watch, errors } = useForm<Inputs>();
    const categorySelected: string = watch('category');

    const _renderInput = (name: keyof Inputs, label: string, required: boolean, errorMessage: string): JSX.Element => {
        return (
            <div className={'msc-form__item'} aria-invalid={errors[name as keyof typeof errors] ? 'true' : 'false'}>
                <label htmlFor={name}>{label}</label>
                <input name={name} ref={register({ required: required })} />
                {errors[name] && <span className={'error-message'}>{errorMessage}</span>}
            </div>
        );
    };

    const _renderCheckbox = (name: keyof Inputs, label: string | React.ReactNode, required: boolean, errorMessage: string): JSX.Element => {
        return (
            <div className={'msc-form__item inputBox privacy_field_ctn'} aria-invalid={errors[name] ? 'true' : 'false'}>
                <label>
                    <input type={'checkbox'} aria-checked='false' name={name} ref={register({ required: true })} />
                    <div>{label} *</div>
                </label>
                {errors[name] && <span className={'error-message'}>This field is required</span>}
            </div>
        );
    };

    const _renderSelect = (
        name: keyof Inputs,
        label: string,
        options: IMaincategories[],
        required: boolean,
        errorMessage: string
    ): JSX.Element => {
        return (
            <div className={'msc-form__item'} aria-invalid={errors[name] ? 'true' : 'false'}>
                <label htmlFor={name}>{label}</label>
                <select name={name} ref={register({ required: true })}>
                    <option aria-selected='true' value=''>
                        Select
                    </option>
                    {options.map(category => {
                        return (
                            <option key={category.value} aria-selected='false' value={category.value}>
                                {category.text}
                            </option>
                        );
                    })}
                    ;
                </select>
                {errors[name] && <span className={'error-message'}>This field is required</span>}
            </div>
        );
    };

    const splitLines = (str: string) => str.split(/\r?\n/);

    const regex = /(<([^>]+)>)/gi;
    // @ts-ignore
    const categoriesText = props.categories.props.text;
    const stripedCatsTextDef = categoriesText.replace(regex, '');
    const stripedCatsText = stripedCatsTextDef.replace('&agrave;', 'à').replace('&amp;', '&');
    const categories = splitLines(stripedCatsText);
    const subCategories: Record<string, IMaincategories[]> = {};
    const mainCategories: IMaincategories[] = [];

    categories.map(category => {
        const catSplit = category.split('|');
        if (catSplit.length === 3) {
            const parentCat = catSplit[1];
            const subcat = {
                text: catSplit[2],
                value: catSplit[0]
            };
            if (subCategories[parentCat] === undefined) {
                subCategories[parentCat] = [];
            }
            subCategories[parentCat].push(subcat);
        }
        if (catSplit.length === 2) {
            const mainCat = {
                text: catSplit[1],
                value: catSplit[0]
            };
            mainCategories.push(mainCat);
        }
    });

    const channelId: number = props.context.request.apiSettings.channelId;
    /*
    const successCallback = (response:string) =>
        handleSubmit((data) => _sendWebForm({ ...data, gRecaptchaResponse: response }))();
    const { recaptchaLoaded, recaptchaWidget } = useRecaptcha({
        containerId,
        successCallback,
        sitekey,
        size: 'invisible'
    });

    const executeCaptcha = (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (recaptchaWidget !== null) {
            // @ts-ignore
            window.grecaptcha.reset(recaptchaWidget);
            // @ts-ignore
            window.grecaptcha.execute(recaptchaWidget);
        }
    };
     */
    return (
        <>
            {props.paragraph}
            {/* "handleSubmit" will validate your inputs before invoking "onSubmit" */}
            {/* tslint:disable-next-line:jsx-no-lambda */}
            <form className={'msc-form'} onSubmit={handleSubmit(_sendWebForm)}>
                {/* handleSubmit(_sendWebForm)*/}
                {_renderInput('title', props.resources.subject, true, 'This field is required')}
                {_renderSelect('category', props.resources.category, mainCategories, true, 'This field is required')}
                {categorySelected &&
                    subCategories[categorySelected] &&
                    _renderSelect(
                        'subcategory',
                        props.resources.subCategory,
                        subCategories[categorySelected],
                        true,
                        'This field is required'
                    )}
                {_renderInput('firstName', props.resources.firstName, true, 'This field is required')}
                {_renderInput('lastName', props.resources.lastName, true, 'This field is required')}
                <div className={'msc-form__item'} aria-invalid={errors.email ? 'true' : 'false'}>
                    <label htmlFor='email'>{props.resources.email}</label>
                    <input
                        name='email'
                        ref={register({
                            required: 'This field is required',
                            pattern: {
                                value: /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
                                message: 'Entered value does not match email format'
                            }
                        })}
                        type='email'
                    />
                    {errors.email && (
                        <span className={'error-message'} role='alert'>
                            {errors.email.message}
                        </span>
                    )}
                </div>
                {_renderInput('phoneNumber', props.resources.phoneNumber, false, '')}
                <div className={'msc-form__item'} aria-invalid={errors.text ? 'true' : 'false'}>
                    <label htmlFor='text'>{props.resources.message}</label>
                    <textarea name='text' ref={register({ required: true })} />
                    {errors.text && <span className={'error-message'}>This field is required</span>}
                </div>
                {locale !== 'en-US' && _renderCheckbox('privacy', props.privacyText, true, 'This field is required')}
                <button type='submit' className={`status__${subscribeMessage.class}`}>
                    {loading ? <div className={'loading'} /> : <span>{props.resources.sendBtn}</span>}
                </button>
                {subscribeMessage.state ? (
                    <div className={`msc-alert msc-alert-${subscribeMessage.class}`} role='alert'>
                        {subscribeMessage.message}
                    </div>
                ) : (
                    ''
                )}
            </form>
        </>
    );
};
export default WebFormView;
